import { useUltimateAlerts } from "../../../context/ultimateAlertsContext"
import useQueryParams from "../../../hooks/useQueryParams"
import useStrings from "../../../localization/useStrings"
import styles from "./ExpirationComparePlansButton.module.scss"

interface Props extends React.PropsWithChildren {
  className?: string
}

const ExpirationComparePlansButton = (props: Props) => {
  const alertActions = useUltimateAlerts().actions
  const strings = useStrings()

  const showUltimateInExpiration = useQueryParams().showUltimateInExpiration

  if (showUltimateInExpiration) {
    return <div />
  }

  return (
    <button
      className={`${styles.button} ${props.className ?? ""}`}
      onClick={() => {
        alertActions.setShowComparePlansSheet(true)
      }}
    >
      {strings.comparePlans.title}
    </button>
  )
}

export default ExpirationComparePlansButton
